/**
 * Browser-safe replica of @maco144/shared's derivePoeticUserId.
 *
 * @maco144/shared's hash() does `require('crypto')`, which is undefined in
 * the browser bundle, so it silently falls back to a weak 32-bit hash
 * padded to 16 hex chars — the first 8 characters are always zero, which is
 * why every browser-created identity's userId (and every @-handle derived
 * from it) showed up as "00000000...". Mirrors the same fix already applied
 * to accord IDs in accord-store.ts: use crypto.ts's real SHA-256, with the
 * same length-prefixed encoding @maco144/shared's hashConcat uses, so the
 * result matches what Node (the server, or an agent-sdk client) would
 * derive from the same phrase.
 */
import type { PoeticIdentity, UserId } from '@maco144/shared';
import { hashConcatLengthPrefixed } from './crypto';

export function derivePoeticUserIdBrowser(identity: PoeticIdentity): UserId {
  return hashConcatLengthPrefixed(
    'poetic-identity-v1',
    identity.adjective.toLowerCase(),
    identity.noun.toLowerCase(),
    identity.verb.toLowerCase()
  ) as UserId;
}
